import { render, staticRenderFns } from "./wangeditor5.vue?vue&type=template&id=b79fc610&scoped=true"
import script from "./wangeditor5.vue?vue&type=script&lang=js"
export * from "./wangeditor5.vue?vue&type=script&lang=js"
import style1 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./wangeditor5.vue?vue&type=style&index=2&id=b79fc610&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b79fc610",
  null
  
)

export default component.exports